import { styled } from '@linaria/react';

export default styled.legend`
  display: block;
  font-weight: 700;
  font-size: 18px;
  line-height: 30px;
  margin-bottom: ${props => (props.hasHint ? '5px' : '10px')};
`;
